import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { assetsState } from '~/state/assets';
import type { GetSessionHydrationQuery } from '~/graphql/types';

/**
 * Uses Recoil to set the assets state.
 * This Recoil state is used in formBuilder/issueState selector to track the errors in the form.
 * It is also useful to render storybook mocks for ImageOrAssetUploadComponent component.
 *
 * @param assets - The assets to set the state to
 */
const useAssetsStateManager = (
  assets: GetSessionHydrationQuery['getSessionHydration']['assets'] | undefined,
) => {
  const setAssets = useSetRecoilState(assetsState);

  useEffect(() => {
    if (assets) {
      setAssets(assets);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assets]);
};

export default useAssetsStateManager;
